import { render, staticRenderFns } from "./TagBox.vue?vue&type=template&id=12968394&"
import script from "./TagBox.vue?vue&type=script&lang=ts&"
export * from "./TagBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports